const METROS = [
  { key: "DFW", label: "DFW", lat: 32.85, lng: -97.0 },
  { key: "HOU", label: "Houston", lat: 29.76, lng: -95.37 },
  { key: "ELP", label: "El Paso", lat: 31.76, lng: -106.44 },
  { key: "LRD", label: "Laredo", lat: 27.53, lng: -99.48 },
];

export const REGION_OPTIONS = [{ key: "all", label: "All" }, ...METROS, { key: "OK", label: "Oklahoma" }];

export const regionOf = (l) => {
  if (l.state === "OK") return "OK";
  let best = null;
  let bestD = Infinity;
  METROS.forEach((m) => {
    const d = (m.lat - l.lat) ** 2 + (m.lng - l.lng) ** 2;
    if (d < bestD) {
      bestD = d;
      best = m.key;
    }
  });
  return best;
};

export const StateToggle = ({ value, onChange, counts, className = "", idPrefix = "state-toggle" }) => (
  <div
    data-testid={idPrefix}
    className={`flex items-center gap-1 bg-slate-900/85 backdrop-blur-xl border border-white/10 rounded-full shadow-2xl p-1 max-w-full overflow-x-auto dfw-scroll ${className}`}
  >
    {REGION_OPTIONS.filter((o) => o.key === "all" || counts[o.key]).map((o) => (
      <button
        key={o.key}
        data-testid={`${idPrefix}-${o.key}`}
        onClick={() => onChange(o.key)}
        className={`shrink-0 px-3.5 py-1.5 rounded-full text-xs font-semibold transition-colors duration-200 whitespace-nowrap ${
          value === o.key ? "bg-white text-[#0B132B]" : "text-slate-300 hover:bg-white/10"
        }`}
      >
        {o.label}
        <span className="ml-1.5 font-mono text-slate-500">{counts[o.key] ?? 0}</span>
      </button>
    ))}
  </div>
);
